import { Tooltip } from "@material-ui/core";
import { Brightness1 } from "@material-ui/icons";
import CopyableCodeCell from "app/common/Component/CopyableCodeCell";
import {
  CHOSE_PRICE_SERVICE,
  FORMAT_DECIMAL_NUMBER,
  FORMAT_MONEY_NUMBER,
  GROUP_SERVICE_CAMPAIGN,
  HIDE_PHONE_NUMBER,
  POSITION_CONSULTANT,
  POSITION_TELESALE,
  PROMOTION_DEFAULT_CODE,
  PAYMENT_METHOD_CODES_REQUIRED_INTEREST_RATE,
  QUANTITY_IAMGE_SHOW_PRINT_FORM_IMAGE_STUDY,
  ROUND_DOWN_HOSPITAL_FEE,
  SERGERYPATIENT_MEDICATION_REQUEST_ORDER_TYPE,
  VIEW_MONTHS_IF_UNDER_5_YEARS_OLD,
} from "app/appConfig";
import { Admin, APPOINTMENT_TYPE } from "app/LocalConstants";
import { NAVIGATION } from "app/navigations";
import localStorageService from "app/services/localStorageService";
import {
  linkGenerateBarcodePatient,
  linkGenerateQrByValue,
} from "app/services/PatientService";
import {
  linkGenerateBarcodePatientPublic,
  linkGenerateQrByValuePublic,
} from "app/services/PublicService";
import { getJustReqNumberToday } from "app/services/RequestNumberService";
import { getStaffById, pagingStaff } from "app/services/StaffService";
import { pagingStoreConfig } from "app/services/StoreConfigService";
import { pagingStore } from "app/services/StoreRequestService";
import axios from "axios";
import moment from "moment";
import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ConstantList from "../appConfig";
import {
  ADMIN_USERNAME,
  APPOINTMENT_STATUS,
  CHOSE_PRICE_SERVICE_OPTIONS,
  COEFFICIENT,
  ENCOUNTER_STATUS,
  ENCOUNTER_STATUS_SERVICE,
  EPISODE_OF_CARE_STATUS,
  HIS_ACCOUNTANT,
  HIS_BALANCE_LOCK_OVERRIDE,
  HIS_BRANCH_MANAGER,
  HIS_CASHIER,
  HIS_CHECKIN_EDIT_ONLY_SOURCE,
  HIS_CHECKIN_EDIT_SOURCE,
  HIS_CHIEF_TECHNICIAN,
  HIS_DOCTOR,
  HIS_EDIT_REVENUE_TYPE,
  HIS_EDIT_WARRANTY,
  HIS_EXPORT_EXCEL,
  HIS_LAB_TEST,
  HIS_MANUAL_EXCHANGE,
  HIS_NURSE,
  HIS_PAYMENT,
  HIS_READ_ONLY,
  HIS_RECEPTIONIST,
  HIS_SALES_CONSULTANT,
  HIS_SHOW_FULL_PHONE_NUMBER,
  HIS_COPY_PHONE_NUMBER,
  HIS_SUBCLINICAL,
  HIS_SUPER_ADMIN,
  HIS_TEAM_LEAD,
  HIS_TECHNICIAN,
  HIS_TOUR_RECONCILIATION,
  HIS_TREATMENT_ASSIGN,
  HIS_VIEW_SENSITIVE_IMAGE,
  INVOICE_TYPE,
  INVOICE_TYPE_BY_ITEM,
  LIST_GENDER,
  LIST_GENDER_CRM,
  LIST_GENDER_HIC,
  LIST_GENDER_NUMBER,
  LIST_INVOICE_STATUS_TYPES,
  LIST_PAYMENT_TYPE,
  LIST_ROOM_TYPES,
  LIST_CUSTOMER_STATUS,
  MEDICATION_REQUEST_TYPE,
  MEDICATION_STATUS_STOCK_OUT,
  PATIENT_TREATMENT_STATUS,
  PAYMENT_METHOD_CHARACTERISTIC_POS,
  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT,
  phoneRegExp,
  ROUND_DOWN_HOSPITAL_LIST,
  SERVICE_REQUEST_STATUS,
  SUBCLINICAL_STATUS,
  TYPE_PRINT_FORM,
  TYPE_PRINT_FORM_EXPORT,
  TYPE_ROOM_DEFAULT,
  VISIT_STATUS,
  VISIT_TYPE,
  HIS_ADMIN,
  HIS_FULL_STAFF_SEARCH,
  FEE_VOUCHER_PRINT_HEADER_MODE,
  FEE_VOUCHER_LEGAL_ENTITY_BY_DEPT,
  FEE_VOUCHER_PRINT_HEADER_MODE_DEPARTMENT,
  FEE_VOUCHER_PRINT_HEADER_MODE_LEGAL_ENTITY,
} from "./LocalConst";

export function getDate(date, titleNoDate = "", stringFormat = "DD/MM/YYYY") {
  if (!date) return titleNoDate;

  if (Array.isArray(date) && date.length >= 3) {
    // Đảm bảo date có đủ thông tin và giảm tháng đi 1
    date = moment([date[0], date[1] - 1, date[2]]);
  } else {
    date = moment(date).local();
  }

  return date.isValid() ? date.format(stringFormat) : titleNoDate;
}

export function getTime(date, titleNoDate = "", stringFormat = "HH:mm") {
  if (!date) return titleNoDate;

  if (Array.isArray(date) && date.length >= 6) {
    date = moment([date[0], date[1] - 1, date[2], date[3], date[4], date[5]]);
  } else if (Array.isArray(date) && date.length >= 3) {
    // Nếu thiếu giờ phút giây, gán mặc định là 00:00:00
    date = moment([date[0], date[1] - 1, date[2], 0, 0, 0]);
  } else {
    date = moment(date);
  }

  return date.isValid() ? date.format(stringFormat) : titleNoDate;
}

export function getDateTime(
  date,
  titleNoDate = "",
  stringFormat = "DD/MM/YYYY HH:mm"
) {
  if (!date) return titleNoDate;

  let momentDate;

  if (Array.isArray(date) && date.length >= 3) {
    // Nếu mảng có ít hơn 6 phần tử, thêm các giá trị mặc định (giờ: 0, phút: 0, giây: 0)
    const [year, month, day, hour = 0, minute = 0, second = 0] = date;
    momentDate = moment([year, month - 1, day, hour, minute, second]);
  } else {
    momentDate = moment(date);
  }

  return momentDate.isValid() ? momentDate.format(stringFormat) : titleNoDate;
}

export function getDateTimeFormat(formatDate) {
  return formatDate
    ? moment(formatDate).hour() +
    " giờ " +
    moment(formatDate).minute() +
    " phút, ngày " +
    moment(formatDate).date() +
    " tháng " +
    (moment(formatDate).month() + 1) +
    " năm " +
    moment(formatDate).year()
    : "....giờ......phút, ngày......tháng.............năm........";
}
export function getDateTimeFormatMR(date) {
  return date
    ? moment(date).hour() +
    " giờ " +
    moment(date).minute() +
    " phút, ngày " +
    moment(date).date() +
    " /" +
    (moment(date).month() + 1) +
    " /" +
    moment(date).year()
    : "....giờ......phút, ngày....../............./........";
}

export function getTimeDate(date) {
  return date
    ? moment(date).hour() +
    ":" +
    moment(date).minute() +
    ", Ngày " +
    moment(date).date() +
    " tháng " +
    (moment(date).month() + 1) +
    " năm " +
    moment(date).year()
    : ".... : ......, Ngày......tháng.............năm........";
}

export function getDateFormat(date) {
  return date
    ? "Ngày " +
    moment(date).date() +
    " tháng " +
    (moment(date).month() + 1) +
    " năm " +
    moment(date).year()
    : "Ngày ...... tháng ............. năm ........";
}

export function getTimeFormat(date) {
  return date
    ? moment(date).hour() +
    " giờ " +
    moment(date).minute() +
    " phút, " +
    getDate(date)
    : "......Giờ.....phút...../....../...........";
}

export function calculateBirthDateFromAge(age) {
  const currentYear = new Date().getFullYear();
  const birthYear = currentYear - age;
  const birthDate = `01/01/${birthYear}`;
  return birthDate;
}

export const getGender = (gender) =>
  LIST_GENDER.find((e) => e.value === gender)?.name;
export const getGenderNumber = (gender) =>
  LIST_GENDER_NUMBER.find((e) => e.value === gender)?.name;
export const getGenderCRM = (gender) =>
  LIST_GENDER_CRM.find((e) => e.value === gender)?.name;
export const getCustomerStatus = (status) =>
  LIST_CUSTOMER_STATUS.find((e) => e.value === status)?.name;

export const withNameSpace = (field, nameSpace) =>
  nameSpace ? `${nameSpace}.${field}` : field;

export const checkValueNoData = (value, titleNoData = "") => {
  return value?.toString() ? value?.toString() : titleNoData;
};

export const transformDate = (_, originalValue) => {
  return originalValue && moment(originalValue).isValid()
    ? new Date(originalValue)
    : originalValue
      ? originalValue
      : null;
};

export const checkSearchObject = (oldValue, newValue) => {
  if ("pageIndex" in newValue && "pageSize" in newValue) {
    oldValue = { ...newValue, pageSize: oldValue.pageSize, pageIndex: 1 };
  } else if ("pageIndex" in newValue) {
    oldValue.pageIndex = newValue.pageIndex;
  } else if ("pageSize" in newValue) {
    oldValue.pageSize = newValue.pageSize;
    oldValue.pageIndex = 1;
  }

  return { ...oldValue, keyword: oldValue?.keyword?.trim() };
};

export const getInvoiceStatus = (invoiceStatus) => {
  if (invoiceStatus) {
    const data = LIST_INVOICE_STATUS_TYPES.find(
      (e) => e.value === invoiceStatus
    );
    return data ? data.name : null;
  }
  return null;
};

export const getInvoiceStatusColor = (invoiceStatus) => {
  if (invoiceStatus) {
    const data = LIST_INVOICE_STATUS_TYPES.find(
      (e) => e.value === invoiceStatus
    );
    return data ? data.color : null;
  }
  return null;
};

export function checkIsSameOrBefore(dateBefore, dateAfter, stringDate) {
  if (
    dateBefore &&
    dateAfter &&
    moment(dateBefore).isValid() &&
    moment(dateAfter).isValid()
  ) {
    return moment(dateBefore).isSameOrBefore(moment(dateAfter), stringDate);
  }
  return true;
}

export function checkIsSameOrAfter(dateBefore, dateAfter, stringDate) {
  if (
    dateBefore &&
    dateAfter &&
    moment(dateBefore).isValid() &&
    moment(dateAfter).isValid()
  ) {
    return moment(dateBefore).isSameOrAfter(moment(dateAfter), stringDate);
  }
  return true;
}

export function checkIsAfter(dateBefore, dateAfter, stringDate) {
  if (
    dateBefore &&
    dateAfter &&
    moment(dateBefore).isValid() &&
    moment(dateAfter).isValid()
  ) {
    return moment(dateBefore).isAfter(moment(dateAfter), stringDate);
  }
  return true;
}

export function formatMoney(number) {
  if (number == null || number === "" || Number.isNaN(number)) {
    return "";
  }
  if (typeof number !== "number" && typeof +number !== "number") {
    return "Invalid input";
  }
  return format2NumberAtferCommaMoneyFormat(number);
  // const formattedNumber = number.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // return formattedNumber;
}

// export function formatMoney(number, unit = '₫') {
//     if (number == null || number === '' || Number.isNaN(number)) {
//         return '';
//     }
//     if (typeof number !== 'number') {
//         return 'Invalid input';
//     }
//     const formattedNumber =
//         number.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
//         (unit ? '' + unit : '');

//     return formattedNumber;
// }

export function formatHIMoney(number, check = false, replace = ".") {
  if (number !== 0 && !number) return "";

  if (typeof number !== "number") {
    return "Invalid input";
  }

  if (check) {
    if (number % 1 !== 0) {
      return number
        .toFixed(FORMAT_MONEY_NUMBER)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, replace);
    }
  }

  return number
    .toFixed()
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, replace);
}

export function format2NumberAtferComma(number, check = false) {
  if (number === 0) return "0,00";
  if (!number || isNaN(number)) {
    return check ? "0" : "0,00";
  }

  if (typeof number === "string") return "0,00";

  // Kiểm tra nếu FORMAT_MONEY_NUMBER không hợp lệ hoặc bằng 0
  const decimalPlaces =
    typeof FORMAT_DECIMAL_NUMBER === "number" && FORMAT_DECIMAL_NUMBER >= 0
      ? FORMAT_DECIMAL_NUMBER
      : 2; // Mặc định là 2 nếu giá trị không hợp lệ

  // Làm tròn số theo số chữ số thập phân được chỉ định
  const roundedNumber = Number(number)?.toFixed(decimalPlaces);

  // Tách phần nguyên và phần thập phân
  const [integerPart, decimalPart] = roundedNumber.split(".");

  // Thêm dấu '.' vào phần nguyên để phân tách hàng nghìn
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    "."
  );

  // Nếu FORMAT_MONEY_NUMBER = 0, không hiển thị phần thập phân
  return decimalPlaces === 0
    ? formattedIntegerPart
    : `${formattedIntegerPart},${decimalPart}`;
}

export function format2NumberAtferCommaMoneyFormat(number, check = true) {
  if (number === 0) return "0";
  if (!number || isNaN(number)) {
    return check ? "0" : "0.00";
  }

  if (typeof number === "string") return "0.00";

  // Kiểm tra nếu FORMAT_MONEY_NUMBER không hợp lệ hoặc bằng 0
  const decimalPlaces =
    typeof FORMAT_MONEY_NUMBER === "number" && FORMAT_MONEY_NUMBER >= 0
      ? FORMAT_MONEY_NUMBER
      : 2; // Mặc định là 2 nếu giá trị không hợp lệ

  // Làm tròn số theo số chữ số thập phân được chỉ định
  const roundedNumber = Number(number)?.toFixed(decimalPlaces);

  // Tách phần nguyên và phần thập phân
  const [integerPart, decimalPart] = roundedNumber.split(".");

  // Thêm dấu '.' vào phần nguyên để phân tách hàng nghìn
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  // Nếu FORMAT_MONEY_NUMBER = 0, không hiển thị phần thập phân
  return decimalPlaces === 0
    ? formattedIntegerPart
    : `${formattedIntegerPart}.${decimalPart}`;
}

export function format2NumberAtferCommaMoney(number, check = true) {
  if (number === 0) return "0";
  if (!number || isNaN(number)) {
    return check ? "0" : "0.00";
  }

  if (typeof number === "string") return "0.00";

  // Kiểm tra nếu FORMAT_MONEY_NUMBER không hợp lệ hoặc bằng 0
  const decimalPlaces = 2; // Mặc định là 2 nếu giá trị không hợp lệ

  // Làm tròn số theo số chữ số thập phân được chỉ định
  const roundedNumber = Number(number)?.toFixed(decimalPlaces);

  // Tách phần nguyên và phần thập phân
  const [integerPart, decimalPart] = roundedNumber.split(".");

  // Thêm dấu '.' vào phần nguyên để phân tách hàng nghìn
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  // Nếu FORMAT_MONEY_NUMBER = 0, không hiển thị phần thập phân
  return decimalPlaces === 0
    ? formattedIntegerPart
    : `${formattedIntegerPart}.${decimalPart}`;
}
// export function format2NumberAtferComma(number, check = false) {
//     if (number !== 0 && !number) return '';

//     if (typeof number !== 'number') {
//         return check ? "0" : 'Invalid input';
//     }

//     // Làm tròn số đến 2 chữ số thập phân
//     const roundedNumber = number.toFixed(FORMAT_MONEY_NUMBER);

//     // Tách phần nguyên và phần thập phân
//     const parts = roundedNumber.split('.');
//     const integerPart = parts[0];
//     const decimalPart = parts[1] || "00";

//     // Thêm dấu ',' vào phần nguyên
//     const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

//     // Kết hợp lại thành chuỗi hoàn chỉnh
//     return `${formattedIntegerPart},${decimalPart}`;
// }

export function renderRoomType(data) {
  return LIST_ROOM_TYPES.find((item) => Number(item?.value) === data?.roomType)
    ?.name;
}

export function checkNullForInputString(inputString) {
  if (typeof inputString !== "string") {
    return null;
  }

  const result = inputString.replace(/\./g, "?.");

  return result;
}

export function daysToTimestamp(days) {
  const millisecondsInADay = 24 * 60 * 60 * 1000; // 1 day = 24 hours * 60 minutes * 60 seconds * 1000 milliseconds
  const timestamp = days * millisecondsInADay;
  return timestamp;
}

export function getNumberOfDrugs(drugOrder) {
  let numberOfDrugs = null;
  if (
    drugOrder &&
    drugOrder?.numberOfPeriod >= 0 &&
    drugOrder?.dosage?.doseValue >= 0
  )
    numberOfDrugs = drugOrder?.numberOfPeriod * drugOrder?.dosage?.doseValue;
  return numberOfDrugs;
}

export function stringToNumber(inputString) {
  // Attempt to parse as an integer
  const parsedInt = parseInt(inputString, 10);

  // If parsing as an integer is successful, return the integer
  if (!isNaN(parsedInt)) {
    return parsedInt;
  }

  // If parsing as an integer fails, attempt to parse as a floating-point number
  const parsedFloat = parseFloat(inputString);

  // If parsing as a floating-point number is successful, return the float
  if (!isNaN(parsedFloat)) {
    return parsedFloat;
  }

  // If parsing both as integer and float fails, return NaN
  return null;
}

export function daysBetweenTimestamps(timestamp1, timestamp2) {
  if (!timestamp1 || !timestamp2) return null;

  const date1 = new Date(timestamp1);
  const date2 = new Date(timestamp2);

  // Calculate the time difference in milliseconds
  const timeDifference = Math.abs(date2 - date1);

  // Convert milliseconds to days
  const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

  if (!daysDifference) {
    return null;
  }

  return stringToNumber(daysDifference);
}

export function round1NumberAfterTheComma(number) {
  if (!number) return null;
  number *= 10;
  number = Math.round(number);
  number /= 10;
  return number;
}

export const getInvoiceType = (invoiceType) => {
  if (invoiceType) {
    const data = INVOICE_TYPE.find((e) => e.value === invoiceType);
    return data ? data.name : null;
  }
  return null;
};

//LET LEFTEYE HAVING TYPE 0
//RIGHT EYE HAVING TYPE 1
//get object having leftEye, rightEye imgs
export const getLeftEye_RightEyeImgs = (digImage) => {
  const data = {
    leftEyeImg: null,
    rightEyeImg: null,
  };

  if (digImage && digImage?.length) {
    if (digImage[0]?.type === 0) {
      data.leftEyeImg = digImage[0];
      if (digImage?.length >= 2) data.rightEyeImg = digImage[1];
    } else if (digImage[0]?.type === 1) {
      data.rightEyeImg = digImage[0];
      if (digImage?.length >= 2) data.leftEyeImg = digImage[1];
    }
  }

  return data;
};

export function getPaymenType(value) {
  for (let i = 0; i < LIST_PAYMENT_TYPE?.length; i++) {
    const currentPT = LIST_PAYMENT_TYPE[i];
    if (value === currentPT?.value) return currentPT;
  }
  return null;
}

export function getTreatmentStatus(value) {
  for (let i = 0; i < PATIENT_TREATMENT_STATUS?.length; i++) {
    const currentTS = PATIENT_TREATMENT_STATUS[i];
    if (Number(value) === Number(currentTS?.value)) return currentTS;
  }
  return null;
}

export function getAgeFromBirthdate(birthdateTimestamp) {
  const currentTimestamp = Math.floor(Date.now() / 1000); // Current timestamp in seconds
  const secondsInYear = 31536000; // Number of seconds in a year (365 days)

  const elapsedTimeInSeconds = currentTimestamp - birthdateTimestamp / 1000;
  const years = Math.floor(elapsedTimeInSeconds / secondsInYear);

  return years;
}

//hàm tính tiền bhyt
export function getAmountInsurance(price, quantity, percent, limit) {
  let total = 0;
  if (percent > 0) {
    if (limit > 0 && limit < price) {
      total = (price - limit * (percent / 100)) * quantity;
    } else {
      total = ((price * (100 - percent)) / 100) * quantity;
    }
  } else {
    total = price * quantity;
  }
  return total;
}

export const getInvoiceCoefficient = (coefficient) => {
  if (coefficient) {
    const data = COEFFICIENT.find((e) => e.value === coefficient);
    return data ? data.name : null;
  }
  return null;
};

export const getInvoiceTypeByItems = (invoiceType) => {
  if (invoiceType) {
    const data = INVOICE_TYPE_BY_ITEM.find((e) => e.value === invoiceType);
    return data ? data.name : null;
  }
  return null;
};

export const getAppointmentType = (type) => {
  if (type) {
    const data = APPOINTMENT_TYPE.find((e) => e.value === type);
    return data ? data.name : null;
  }
  return null;
};

export function getYear(year, titleNoYear = "", stringFormate = "YYYY") {
  return year && moment(year).isValid()
    ? moment(year).format(stringFormate)
    : titleNoYear;
}

export const getCurrentStaff = () => {
  if (localStorageService?.getLoginUser()) {
    const { user } = localStorageService.getLoginUser();
    if (user?.personId && user?.username !== ADMIN_USERNAME) {
      return {
        id: user?.personId,
        staffName: user?.displayName,
        roomName: user?.room?.name || "",
        code: user?.staff?.code,
        position: user?.staff?.position,
        roles: user?.staff?.roleExs,
      };
    } else {
      return null;
    }
  }
  return null;
};

export const getCurrentRoomByStaff = () => {
  if (localStorageService?.getLoginUser()) {
    const { user } = localStorageService.getLoginUser();
    if (user?.staff?.staffRooms?.length > 0) {
      return user?.staff?.staffRooms;
    }
    return "";
  }
  return null;
};

export const getCurrentDepartmentByRooms = () => {
  if (localStorageService?.getLoginUser()) {
    const { user } = localStorageService.getLoginUser();
    if (user?.staff?.staffRooms?.length > 0) {
      return Array.from(
        new Set(
          user?.staff?.staffRooms?.map((item) => item?.department?.id) || []
        )
      ).map(
        (id) =>
          user.staff.staffRooms.find((item) => item.department.id === id)
            ?.department
      );
    }
    return "";
  }
  return null;
};

export const getCurrentDepartmentByStaff = () => {
  if (localStorageService?.getLoginUser()) {
    const { user } = localStorageService.getLoginUser();
    return user?.staff?.department || "";
  }
  return null;
};

export const getImgLogo = ({ height = "80px", width = "80px" } = {}) => {
  let imgLogo = localStorageService?.getItem("imgLogo");
  if (imgLogo) {
    return <img src={imgLogo} alt="Logo" style={{ height, width }} />;
  }
  return "";
};

export const getImgLogoTreamentPrint = ({
  height = "80px",
  width = "80px",
} = {}) => {
  let imgLogoTreamentPrint = localStorageService?.getItem(
    "treatmentPlanCardPrintLogo"
  );
  if (imgLogoTreamentPrint) {
    return (
      <img src={imgLogoTreamentPrint} alt="Logo" style={{ height, width }} />
    );
  }
  return "";
};

export function getAuthUserData() {
  // Check if local storage is supported by the browser
  if (typeof localStorage !== "undefined") {
    // Get the value associated with the "auth_user" key
    var authUserDataJSON = localStorage.getItem("auth_user");
    if (authUserDataJSON !== null) {
      try {
        // Parse the JSON data and return as an object
        var authUserData = JSON.parse(authUserDataJSON);
        return authUserData;
      } catch (error) {
        return null;
      }
    } else {
      return null; // No auth user data found
    }
  } else {
    return null;
  }
}

//lấy ra bác sĩ mặc định theo tk
export const createDefaultPractititioner = async (props) => {
  const currentUser = getAuthUserData();
  const staffId = currentUser?.user?.person?.id;
  let staff = {};

  if (staffId && staffId.length > 0) {
    const { data } = await getStaffById(staffId);
    if (data) {
      staff = data;
    } else {
      const { data } = await pagingStaff({
        pageIndex: 1,
        pageSize: 1,
        ...props,
      });
      staff = data?.content?.[0] || {};
    }
  }

  return staff;
};

export const staffPermissonHealth = () => {
  let { user } = localStorageService?.getLoginUser();
  return !!(
    (user?.staff && user?.staff?.insName && user?.staff?.insPIN) ||
    isAdmin()
  );
};

export const getVisitStatus = (visitStatus) => {
  return (
    VISIT_STATUS.find((item) => Number(item?.value) === visitStatus)?.name ||
    "Không rõ trạng thái"
  );
};

export const getVisitStatusIcon = (visitStatus, convestName) => {
  const find = VISIT_STATUS.find((item) => Number(item?.value) === visitStatus);

  return (
    <Tooltip title={convestName ? convestName(find?.name) : find?.name}>
      <span>{find?.icon}</span>
    </Tooltip>
  );
};
export const getEncounterStatusIcon = (encounterStatus, convestName) => {
  const find = ENCOUNTER_STATUS.find(
    (item) => Number(item?.value) === encounterStatus
  );

  return (
    <Tooltip title={convestName ? convestName(find?.name) : find?.name}>
      <span>{find?.icon}</span>
    </Tooltip>
  );
};

export const getEncounterStatusIconService = (encounterStatus, convestName) => {
  const find = ENCOUNTER_STATUS_SERVICE.find(
    (item) => Number(item?.value) === encounterStatus
  );

  return (
    <Tooltip title={convestName ? convestName(find?.name) : find?.name}>
      <span>{find?.icon}</span>
    </Tooltip>
  );
};

export const getSubclinicalStatus = (subclinicalStatus) => {
  return (
    SUBCLINICAL_STATUS.find((item) => Number(item?.value) === subclinicalStatus)
      ?.name || ""
  );
};

export const getSubclinicalStatusIcon = (subclinicalStatus) => {
  const find = SUBCLINICAL_STATUS.find(
    (item) => Number(item?.value) === subclinicalStatus
  );

  return (
    <Tooltip title={find?.name}>
      <span>{find?.icon}</span>
    </Tooltip>
  );
};
export const getAppointmentStatusIcon = (appointmentStatus) => {
  const find = APPOINTMENT_STATUS.find(
    (item) => Number(item?.value) === appointmentStatus
  );

  return (
    <Tooltip title={find?.name}>
      <span>{find?.icon}</span>
    </Tooltip>
  );
};

export const getEpisodeOfCareStatus = (episodeOfCareStatus) => {
  return (
    EPISODE_OF_CARE_STATUS.find(
      (item) => Number(item?.value) === episodeOfCareStatus
    )?.name || "Không rõ trạng thái"
  );
};

export const getEpisodeOfCareStatusIcon = (visitStatus) => {
  const find = EPISODE_OF_CARE_STATUS.find(
    (item) => Number(item?.value) === visitStatus
  );

  return (
    <Tooltip title={find?.name}>
      <span>{find?.icon}</span>
    </Tooltip>
  );
};

export const getFormData = (object) => {
  const formData = new FormData();

  for (const key in object) {
    formData.append(key, object[key]);
  }

  return formData;
};

export const getGenderHIC = (gender) =>
  LIST_GENDER_HIC.find((e) => e.value === gender)?.name;

export const getDisplayAddress = (patient) => {
  let address = "";
  if (patient?.currentDetailResidence) {
    address = patient?.currentDetailResidence;
  }
  if (patient?.currentWard?.name) {
    if (address) address += " - ";
    address += patient?.currentWard?.name;
  }
  if (patient?.currentDistrict?.name) {
    if (address) address += " - ";
    address += patient?.currentDistrict?.name;
  }
  if (patient?.currentProvince?.name) {
    if (address) address += " - ";
    address += patient?.currentProvince?.name;
  }
  return address;
};

export const getInsurancePaymentType = (type) => {
  return LIST_PAYMENT_TYPE.find((item) => Number(item?.value) === type)?.name;
};

export const getCurrentRequestNumber = (type) => {
  if (
    localStorageService.getRequestNumber() &&
    localStorageService.getRequestNumber() > 0
  ) {
    return localStorageService.getRequestNumber();
  } else {
    //find db
    getJustReqNumberToday().then(({ data }) => {
      return data;
    });
  }
};

export function getAge(birthDate) {
  if (!birthDate || isNaN(new Date(birthDate).getTime())) {
    return null; // Kiểm tra ngày sinh hợp lệ
  }

  const today = new Date();
  const birth = new Date(birthDate);

  // Tính tổng số tháng tuổi
  let totalMonths =
    (today.getFullYear() - birth.getFullYear()) * 12 +
    (today.getMonth() - birth.getMonth());

  // Nếu chưa đến ngày sinh nhật trong tháng hiện tại, giảm đi 1 tháng
  if (today.getDate() < birth.getDate()) {
    totalMonths--;
  }

  // Nếu bật cấu hình và dưới 60 tháng (5 tuổi) => Trả về số tháng
  if (
    VIEW_MONTHS_IF_UNDER_5_YEARS_OLD &&
    totalMonths >= 1 &&
    totalMonths <= 60
  ) {
    return `${totalMonths} tháng`;
  }

  // Nếu tháng < 1, hiển thị số ngày tuổi
  if (totalMonths < 1) {
    const totalDays = Math.floor((today - birth) / (1000 * 60 * 60 * 24));
    return `${totalDays} ngày`;
  }

  // Tính số năm tuổi
  const age = Math.floor(totalMonths / 12);

  // Nếu chưa đủ 12 tháng (1 tuổi), vẫn hiển thị "0 tuổi"
  return age < 1 ? "0 tuổi" : `${age} tuổi`;
}

export function getAgeInt(birthDate) {
  if (!birthDate || isNaN(new Date(birthDate).getTime())) {
    return null; // Kiểm tra ngày sinh hợp lệ
  }

  const today = new Date();
  const birth = new Date(birthDate);

  // Tính tổng số tháng tuổi
  let totalMonths =
    (today.getFullYear() - birth.getFullYear()) * 12 +
    (today.getMonth() - birth.getMonth());

  // Nếu chưa đến ngày sinh nhật trong tháng hiện tại, giảm đi 1 tháng
  if (today.getDate() < birth.getDate()) {
    totalMonths--;
  }

  // Nếu bật cấu hình và dưới 60 tháng (5 tuổi) => Trả về số tháng
  if (
    VIEW_MONTHS_IF_UNDER_5_YEARS_OLD &&
    totalMonths >= 1 &&
    totalMonths <= 60
  ) {
    return totalMonths;
  }

  // Nếu tháng < 1, hiển thị số ngày tuổi
  if (totalMonths < 1) {
    const totalDays = Math.floor((today - birth) / (1000 * 60 * 60 * 24));
    return totalDays;
  }

  // Tính số năm tuổi
  const age = Math.floor(totalMonths / 12);

  // Nếu chưa đủ 12 tháng (1 tuổi), vẫn hiển thị "0 tuổi"
  return age < 1 ? 0 : age;
}

export function getTwoDigitDay(date) {
  var day = date || new Date().getDate();
  var twoDigitDay = day < 10 ? "0" + day : "" + day;
  return twoDigitDay;
}

export function getTwoDigitMonth(date) {
  var month = date || new Date().getMonth() + 1;
  var twoDigitMonth = month < 10 ? "0" + month : "" + month;
  return twoDigitMonth;
}

export function getExpiryDayOfInsurance(expiryDate) {
  if (expiryDate && moment(expiryDate).isValid()) {
    expiryDate = moment(expiryDate).startOf("day");
    const currentDate = moment(new Date()).startOf("day");
    const days = expiryDate.diff(currentDate, "days");
    if (Number(days) + 1 > 0) {
      return Number(days) + 1;
    } else {
      return 0;
    }
  }
}

export const handleGetQRCode = async (code) => {
  let api = linkGenerateBarcodePatient;
  const isPublic = window.location.href.includes("public");
  if (isPublic) {
    api = linkGenerateBarcodePatientPublic;
  }
  try {
    const response = await api(code);
    const base64String = btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ""
      )
    );
    return `data:image/jpeg;base64,${base64String}`;
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const handleGetQRCodeByValue = async (code) => {
  const isPublic = window.location.pathname.includes("public");
  let api = linkGenerateQrByValue;
  if (isPublic) {
    api = linkGenerateQrByValuePublic;
  }
  try {
    const response = await api({
      qrContent: code,
    });
    const base64String = btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ""
      )
    );
    return `data:image/jpeg;base64,${base64String}`;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const base64ToFile = (base64String, fileName) => {
  // Tách header và dữ liệu Base64
  const [header, data] = base64String.split(",");
  const mime = header.match(/:(.*?);/)[1]; // Lấy MIME type (ví dụ: image/jpeg)
  const byteCharacters = atob(data);
  const byteNumbers = Array.from(byteCharacters).map((char) =>
    char.charCodeAt(0)
  );
  const byteArray = new Uint8Array(byteNumbers);

  // Tạo File từ Blob
  const file = new File([byteArray], fileName, { type: mime });
  return file;
};

export const checkIsRole = (role) => {
  let value = localStorageService?.getLoginUser();
  if (value?.user?.roles?.some((s) => s?.authority === role)) {
    return true;
  }
  return false;
};
export const isSuperAdmin = () => checkIsRole(HIS_SUPER_ADMIN);
export const isAdmin = () => checkIsRole(Admin);
export const isDoctor = () => checkIsRole(HIS_DOCTOR);
export const isLabTest = () => checkIsRole(HIS_LAB_TEST);
export const isNurse = () => checkIsRole(HIS_NURSE);
export const isSubclinical = () => checkIsRole(HIS_SUBCLINICAL);
export const isReceptionist = () => checkIsRole(HIS_RECEPTIONIST);
export const isSalesConsultant = () => checkIsRole(HIS_SALES_CONSULTANT);
export const isRoleBranchManager = () => checkIsRole(HIS_BRANCH_MANAGER);
export const isRoleCashier = () => checkIsRole(HIS_CASHIER);
export const isRoleTechician = () => checkIsRole(HIS_TECHNICIAN);
export const isRoleChiefTechician = () => checkIsRole(HIS_CHIEF_TECHNICIAN);
export const isRoleHisReadOnly = () => checkIsRole(HIS_READ_ONLY);
export const isRoleHisAccountant = () => checkIsRole(HIS_ACCOUNTANT);
export const isRoleHisTreatmentAssign = () => checkIsRole(HIS_TREATMENT_ASSIGN);
export const isRoleHisPayment = () => checkIsRole(HIS_PAYMENT);
export const isRoleHisShowFullPhone = () =>
  checkIsRole(HIS_SHOW_FULL_PHONE_NUMBER);
export const isRoleHisCopyPhone = () => checkIsRole(HIS_COPY_PHONE_NUMBER);
export const isRoleHisTeamLead = () => checkIsRole(HIS_TEAM_LEAD);
export const isRoleCheckinEditSource = () => checkIsRole(HIS_CHECKIN_EDIT_SOURCE);
export const isRoleCheckinEditOnlySource = () => checkIsRole(HIS_CHECKIN_EDIT_ONLY_SOURCE);
export const isRoleTourReconciliation = () => checkIsRole(HIS_TOUR_RECONCILIATION);
export const isRoleManualExchange = () => checkIsRole(HIS_MANUAL_EXCHANGE);
export const isRoleisRoleEditWarranty = () => checkIsRole(HIS_EDIT_WARRANTY);
export const isRoleisBalanceLockOverride = () => checkIsRole(HIS_BALANCE_LOCK_OVERRIDE);
export const isRoleExportExcel = () => checkIsRole(HIS_EXPORT_EXCEL);
export const isRoleViewSensitiveImage = () => checkIsRole(HIS_VIEW_SENSITIVE_IMAGE);
export const isRoleEditRevenueType = () => checkIsRole(HIS_EDIT_REVENUE_TYPE) || checkIsRole(HIS_ADMIN);
export const canBypassVisitBasedStaffSearch = () =>
  isAdmin() || isSuperAdmin() || checkIsRole(HIS_FULL_STAFF_SEARCH);

export const getVisitType = (visitType) =>
  VISIT_TYPE?.find((i) => i?.value === visitType)?.name;
export const getServiceRequestStatus = (serviceRequestStatus) => {
  return (
    SERVICE_REQUEST_STATUS.find(
      (item) => Number(item?.value) === serviceRequestStatus
    )?.name || ""
  );
};

export const handlePrint = (value) => {
  let content = value;

  if (typeof value === "string") {
    content = document.getElementById(value);
  }

  const print = document.createElement("iframe");
  print.setAttribute("id", "iframeContentPrint");
  document.body.appendChild(print);
  let pri = print.contentWindow;
  pri.document.open();
  pri.document.write(content.innerHTML);
  pri.document.close();
  pri.focus();
  pri.print();
  document.body.removeChild(print);
};

export const getMedicationStatus = (status) => {
  return MEDICATION_STATUS_STOCK_OUT.find(
    (item) => Number(item?.value) === status
  )?.name;
};

export const getDateFormatOnlyCharacter = (date) => {
  if (!date) return;
  const dateFormat = new Date(date);
  const year = dateFormat.getFullYear().toString();
  const month = getTwoDigitMonth(dateFormat.getMonth() + 1);
  const day = getTwoDigitDay(dateFormat.getDate());

  const [dayFirstDigit, daySecondDigit] = day.split("");
  const [monthFirstDigit, monthSecondDigit] = month.split("");
  const [yearDigit1, yearDigit2, yearDigit3, yearDigit4] = year.split("");

  return {
    dayFirstDigit,
    daySecondDigit,
    monthFirstDigit,
    monthSecondDigit,
    yearDigit1,
    yearDigit2,
    yearDigit3,
    yearDigit4,
  };
};

export const getPrice = (patientType, option) => {
  //tam thoi lay gia theo doi tuong - sau nay can lay theo khu (posCode)
  return option?.find(
    (item) => item?.patientTypeService?.id === patientType?.id
  )?.price;
};

export const getPriceTypeService = (patientType, option, quantity) => {
  let list = option || [];
  if (quantity !== undefined && quantity !== null) {
    const matchingFees = list.filter((item) => {
      const from = item.fromQuantity;
      const to = item.toQuantity;
      if (from === null && to === null) return false;
      if (from !== null && to !== null) return quantity >= from && quantity <= to;
      if (from !== null) return quantity >= from;
      if (to !== null) return quantity <= to;
      return false;
    });
    if (matchingFees.length > 0) {
      list = matchingFees;
    }
  }

  if (CHOSE_PRICE_SERVICE === CHOSE_PRICE_SERVICE_OPTIONS[1]?.value) {
    const priceType = list?.find((item) => item.isDefault) || null;
    const byPatientType = list.find(
      (item) => item?.patientTypeService?.id === patientType?.id
    );

    if (priceType) return priceType;
    if (byPatientType) return byPatientType;
    if (list?.length > 0) return list[0];

    return { patientTypeService: patientType };
  }

  let patientTypeService = list?.find(
    (item) => item?.patientTypeService?.id === patientType?.id
  );
  return patientTypeService || { patientTypeService: patientType };
};

export const getIsUseIns = (patientType, patientPriceType) => {
  return patientType?.isSendHIPrice && patientPriceType?.isUseHealthInsurance;
};

export const getMedicationRequestTypePrint = (type) => {
  return MEDICATION_REQUEST_TYPE?.find((f) => f?.value === type)?.name || "";
};

export const formatNumber = (number) => {
  return format2NumberAtferComma(number);
};

export const TextView = ({
  style,
  label,
  value,
  readonlyValue,
  maskPhone = false,
  numberLine = 1,
  className = "",
  width,
  breakLineLabel,
}) => {
  const lineHeight = 20;
  const height = numberLine * lineHeight;

  return (
    <div
      style={{
        width: width || "100%",
        minHeight: value && readonlyValue ? "auto" : height || "auto",
        textAlign: "left",
        position: "relative",
        ...(style ? style : {}),
      }}
      className={`page_break_inside-avoid ${className}`}
    >
      <span
        style={{
          position: "relative",
          zIndex: "1",
          backgroundColor: "#ffffff",
        }}
      >
        {label && <span dangerouslySetInnerHTML={{ __html: `${label} : ` }} />}
        {breakLineLabel && <br />}
        {value &&
          (isCopyableCodeLabel(String(label || "").replace(/<[^>]*>/g, "")) ? (
            <CopyableCodeCell value={value} size="small" />
          ) : (
            <span style={{ whiteSpace: "pre-wrap" }}>
              {maskPhone ? formatPhoneDisplayValue(value) : value}
            </span>
          ))}
      </span>

      {useMemo(
        () =>
          (!readonlyValue || !value) && (
            <span
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "block",
                overflow: "hidden",
                whiteSpace: "pre-wrap",
                lineHeight: `${lineHeight}px`,
                height: `${height}px`,
              }}
            >
              {Array.from({ length: numberLine }).map((_, idx) => (
                <React.Fragment key={idx}>
                  {
                    "............................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................\n"
                  }
                </React.Fragment>
              ))}
            </span>
          ),
        [numberLine, readonlyValue, value, lineHeight, height]
      )}
    </div>
  );
};

export const closeChildren = (parentIndex, setChildState) => {
  setChildState((prevChildStatus) => {
    const updatedChildStatus = { ...prevChildStatus };
    if (updatedChildStatus[parentIndex]) {
      Object.keys(updatedChildStatus[parentIndex]).forEach((childIndex) => {
        updatedChildStatus[parentIndex][childIndex] = false;
      });
    }
    return updatedChildStatus;
  });
};

export const getBMI = (weight, height) => {
  let BMI = "";
  if (Number(weight) > 0 && Number(height) > 0) {
    BMI = Number(weight) / (Number(height / 100) * Number(height / 100));
  } else return "(---)";
  return isNaN(BMI) || BMI <= 0 ? "" : Number(BMI).toFixed(2);
};

const resolvePatientInfoDisplayValue = (label, value, noInfo) => {
  if (noInfo) return value;
  if (typeof value !== "string" && typeof value !== "number" && value) {
    return value;
  }
  if (!value && value !== 0) {
    return checkValueNoData(value, "(---)");
  }
  return isPhoneDisplayLabel(label)
    ? formatPhoneDisplayValue(value)
    : checkValueNoData(value, "(---)");
};

export const ItemInfoPatient = memo(({ label, value, noInfo, className }) => {
  const displayValue = resolvePatientInfoDisplayValue(label, value, noInfo);
  const showCopyableCode =
    isCopyableCodeLabel(label) && displayValue && displayValue !== "(---)";

  return (
    <p className={className}>
      <span>{label ? label + ":  " : ""}</span>
      <strong className="text-blue">
        {showCopyableCode ? (
          <CopyableCodeCell value={displayValue} size="small" />
        ) : (
          displayValue
        )}
      </strong>
    </p>
  );
});

export const ItemForcusDanger = memo(({ label, value, noInfo }) => (
  <p className="flex align-center">
    <span>{label ? label + ":  " : ""}</span>
    <strong className="text-danger makeStyles-currentPage-5 flex-center">
      {!noInfo
        ? typeof value === "string" || typeof value === "number" || !value
          ? checkValueNoData(value, "(---)")
          : value
        : value}
    </strong>
  </p>
));

export const ItemForcus = memo(({ label, value, noInfo, start }) => {
  const displayValue = resolvePatientInfoDisplayValue(label, value, noInfo);
  const showCopyableCode =
    isCopyableCodeLabel(label) && displayValue && displayValue !== "(---)";

  return (
    <p className={`flex ${start ? "align-center" : "align-start"}`}>
      <span className="mr-1" style={{ whiteSpace: "nowrap" }}>
        {label ? label + ":  " : ""}
      </span>
      <strong className="flex-center">
        {showCopyableCode ? (
          <CopyableCodeCell value={displayValue} size="small" />
        ) : (
          displayValue
        )}
      </strong>
    </p>
  );
});

// lay ra ngay dau va cuoi trong tuan
export const getStartAndEndOfWeek = (date) => {
  const currentDate = moment(new Date(date));
  const startOfWeek = currentDate.clone().startOf("isoWeek"); // Sử dụng isoWeek để đảm bảo bắt đầu từ Thứ Hai
  const endOfWeek = currentDate.clone().endOf("isoWeek");

  return {
    startTime: startOfWeek,
    endTime: endOfWeek,
  };
};

export const fetchImageAsFile = async (url, fileName) => {
  const response = await fetch(url);
  const blob = await response.blob();
  const file = new File([blob], fileName, { type: blob.type });
  return file;
};

export function convertIfNumber(value) {
  if (typeof value === "string" || value instanceof String) {
    // Sử dụng parseFloat để ép kiểu và kiểm tra nếu không phải NaN
    const numberValue = parseFloat(value);

    // Kiểm tra nếu không phải là NaN và chuỗi không trống sau khi trim
    if (!isNaN(numberValue) && value.trim() !== "") {
      return numberValue; // Ép thành số
    }

    return value; // Giữ nguyên chuỗi
  }

  return value;
}

export const IconDescription = ({ list, style, otherList, align = "left" }) => {
  const { t } = useTranslation();
  const renderIconDesc = (f) => {
    return (
      <div
        className="flex flex-middle mr-3 gap-1 flex-wrap"
        style={{ zoom: "0.8" }}
      >
        {f?.icon ? (
          f?.icon
        ) : (
          <Brightness1 style={{ color: f?.color, ...style }} />
        )}
        {t(`${f?.name}`)}
      </div>
    );
  };

  return (
    <section className={`flex flex-wrap justify-${align}`} style={{ ...style }}>
      {list?.map(renderIconDesc)}
      {otherList && otherList?.map(renderIconDesc)}
    </section>
  );
};

//type : xem ở TYPE_ROOM_DEFAULT
export const getDefaultRoomByType = async (type) => {
  let room = localStorageService?.getDefaultRoom();
  let defaultRoom = null;
  let tyeValue = TYPE_ROOM_DEFAULT?.find((item) => item?.prod === type)?.value;
  if (tyeValue) {
    if (room) {
      defaultRoom = room?.[tyeValue];
    } else {
      await axios
        .get(
          ConstantList.API_EN_POINT +
          "/health-care-room/get-default-room-by-type-map"
        )
        .then((response) => {
          if (response?.data) {
            localStorageService.setItem("default_room", response?.data);
            defaultRoom = response?.data?.[tyeValue];
          }
        });
    }
  }
  return defaultRoom;
};

export const filterByName = (name, list, keyword, displayValue = "name") => {
  let listFilter = [];
  if (typeof name === "string") {
    listFilter = list?.filter((item) => item?.[name] === keyword);
  } else if (typeof name === "object") {
    listFilter = list?.filter(
      (item) => item?.[name]?.[displayValue] === keyword
    );
  }
  return listFilter || [];
};

export const numberToWords = (num) => {
  const units = [
    "",
    "một",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín",
  ];
  const tens = ["", "", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const scales = ["", "nghìn", "triệu", "tỷ"];

  if (num === 0) return "không";

  let words = [];
  let scaleIndex = 0;

  while (num > 0) {
    const chunk = num % 1000; // Lấy 3 chữ số cuối cùng
    if (chunk > 0) {
      let chunkWords = [];
      const hundreds = Math.floor(chunk / 100);
      const remainder = chunk % 100;
      const tensDigit = Math.floor(remainder / 10);
      const unitDigit = remainder % 10;

      if (hundreds > 0) {
        chunkWords.push(units[hundreds], "trăm");
      }

      if (tensDigit > 1) {
        chunkWords.push(tens[tensDigit], "mươi");
        if (unitDigit > 0) {
          chunkWords.push(units[unitDigit]);
        }
      } else if (tensDigit === 1) {
        chunkWords.push("mười");
        if (unitDigit > 0) {
          chunkWords.push(unitDigit === 5 ? "lăm" : units[unitDigit]);
        }
      } else if (unitDigit > 0) {
        chunkWords.push(units[unitDigit]);
      }

      if (scaleIndex > 0) {
        chunkWords.push(scales[scaleIndex]);
      }

      words.unshift(chunkWords.join(" "));
    }

    num = Math.floor(num / 1000);
    scaleIndex++;
  }

  return `${words?.length > 0 ? words.join(" ") : "Không "} đồng`;
};

export const currentModule = () => {
  const currentPath = window.location.pathname;
  let module = NAVIGATION.find((e) => currentPath.includes(e.path));
  let { name, path } = module;
  return { name, path };
};

//PTTT
export const SERGERYPATIENT_MEDICATION_REQUEST = "sergeryPatient";
export const INPATIENT_MEDICATION_REQUEST = "inPatient";

export const setInitDrugInPatient = async (drugPre, data, valueType, type) => {
  let initDrug = {};
  let nameSpace = valueType === 2 ? "syntheticMediReq" : "isuranceMediRequest";
  let defaultStore =
    drugPre?.[nameSpace]?.initValue?.store ||
    drugPre?.medicalSupplyRequest?.store;
  if (!defaultStore) {
    let { data: store } = await pagingStoreConfig({
      storeType: 2,
      pageIndex: 1,
      pageSize: 1,
      patientTypeService: drugPre?.patientTypeService,
    });
    defaultStore = store?.content?.[0];
  }

  let isBasic = !!(valueType === SERGERYPATIENT_MEDICATION_REQUEST_ORDER_TYPE);
  let isSurgery = !!(
    typeof type === "string" && type?.toLowerCase() === "surgery"
  );

  if (valueType === 2) {
    initDrug.syntheticMediReq = {
      ...data?.syntheticMediReq,
      orderDate: new Date(),
      isBasic: isBasic,
      initValue: {
        isBasic: isBasic,
        isChargeable: isSurgery ? false : true,
        store:
          drugPre?.syntheticMediReq?.store ||
          data?.room?.department?.storeConfig ||
          defaultStore,
      },
    };
  } else {
    initDrug.isuranceMediRequest = {
      ...data?.isuranceMediRequest,
      orderDate: new Date(),
      isBasic: isBasic,
      initValue: {
        isBasic: isBasic,
        isChargeable: true,
        store:
          drugPre?.isuranceMediRequest?.store ||
          data?.room?.department?.insuranceStoreConfig ||
          defaultStore,
      },
    };
    initDrug.serviceMediRequest = {
      ...data?.serviceMediRequest,
      orderDate: new Date(),
      isBasic: isBasic,
      initValue: {
        isBasic: isBasic,
        isChargeable: true,
        store:
          drugPre?.serviceMediRequest?.store ||
          data?.room?.department?.serviceStoreConfig ||
          defaultStore,
      },
    };
    initDrug.otherMediRequest = {
      ...data?.otherMediRequest,
      orderDate: new Date(),
      isBasic: isBasic,
      initValue: {
        isBasic: isBasic,
        isChargeable: false,
        store:
          drugPre?.otherMediRequest?.store ||
          data?.room?.department?.externalStoreConfig ||
          defaultStore,
      },
    };
  }

  let initMedicalSupply = await setInitMedicalSupply(drugPre, data);

  return { ...initDrug, ...initMedicalSupply };
};

export const setInitMedicalSupply = async (obj, data) => {
  let initMedicalSupply = {};
  let defaultStore = obj?.syntheticMedicalSupplyRequest?.store;
  let defaultStoreConsumables = obj?.consumablesMedicalSupplyRequest?.store;
  if (!defaultStore || !defaultStoreConsumables) {
    let { data: store } = await pagingStoreConfig({
      storeType: 2,
      pageIndex: 1,
      pageSize: 1,
      patientTypeService: obj?.patientTypeService,
    });
    defaultStore = store?.content?.[0];
  }

  initMedicalSupply.syntheticMedicalSupplyRequest = {
    orderDate: new Date(),
    ...data?.syntheticMedicalSupplyRequest,
    fromDate: new Date(),
    initValue: {
      store: defaultStore,
      isChargeable: true,
    },
  };
  initMedicalSupply.consumablesMedicalSupplyRequest = {
    orderDate: new Date(),
    ...data?.consumablesMedicalSupplyRequest,
    fromDate: new Date(),
    initValue: {
      store: defaultStoreConsumables,
      isChargeable: true,
    },
  };

  return initMedicalSupply;
};

export const checkPhoneNumber = (value) => {
  if (value === null || value === undefined || value?.length === 0) {
    return true;
  } else {
    return !value.match(phoneRegExp);
  }
};

export const fetchDataBanks = (callback) => {
  const localListBank = localStorageService.getItem("listBank");

  if (localListBank?.length > 0) {
    if (typeof callback === "function") {
      callback(localListBank);
    }
  } else {
    fetch("https://api.vietqr.io/v2/banks")
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        localStorageService.setItem("listBank", res?.data);
        if (typeof callback === "function") {
          callback(res?.data);
        }
        return res;
      });
  }
};

export const getTitlePrint = (printData, type = TYPE_PRINT_FORM_EXPORT) => {
  const config = localStorageService.getPrintFormCode() || "{}";
  const PRINT_FORM_CODE = JSON.parse(config);
  let title = `${TYPE_PRINT_FORM.find((el) => el.value == type).label} ${PRINT_FORM_CODE?.[printData?.printFormCode] || " thuốc"
    }`;

  return title;
};

export const getTypePrint = (printData) => {
  let type = "";

  if (printData?.storeRequest?.source?.code === "BH") {
    type += ` (nguồn bảo hiểm)`;
  } else if (printData?.storeRequest?.source?.code === "DV") {
    type += ` (nguồn dịch vụ)`;
  }

  return type;
};

export const getTitlePrintV2 = (printData, type = TYPE_PRINT_FORM_EXPORT) => {
  const config = localStorageService.getPrintFormCode();
  const PRINT_FORM_CODE = JSON.parse(config);
  console.log("PRINT_FORM_CODE", PRINT_FORM_CODE);
  let title = ` ${PRINT_FORM_CODE?.[printData?.printFormCode] || "THUỐC"}`;

  return title;
};

//   export const getTitlePrintV2 = (printData,type =TYPE_PRINT_FORM_EXPORT) => {
//     const config = localStorageService.getPrintFormCode()
//     const PRINT_FORM_CODE = JSON.parse(config);
//     console.log('PRINT_FORM_CODE',PRINT_FORM_CODE)
//     let title = `${TYPE_PRINT_FORM.find(el => el.value == type).label} ${PRINT_FORM_CODE?.[printData?.printFormCode] || ""}`

//     return title;
//   }

export const getDateAsText = (date) => {
  if (date && moment(date).isValid()) {
    return `Ngày ${moment(date).format("DD")} tháng ${moment(date).format(
      "MM"
    )} năm ${moment(date).format("YYYY")}`;
  }
  return "";
};

export const convertKbToMb = (kb) => {
  return kb > 0 ? (kb / 1024).toFixed(2) + "MB" : "";
};

export const handleDefaultStoreByCode = async (code) => {
  let store;
  const { data } = await pagingStore({
    code: code,
    pageIndex: 1,
    pageSize: 10,
  });
  if (data?.content?.length > 0) {
    store = data?.content?.[0];
  }
  return store;
};

export const getSystemConfig = (key) => {
  const data = localStorageService.getItem("sysConfig") || {};
  if (data === null || data === undefined) return null;
  return data?.[key] !== null || data?.[key] !== undefined ? data?.[key] : null;
};

/** Parse system config JSON (string hoặc đã là object/array). */
export const parseSystemConfigJson = (raw, fallback = null) => {
  if (raw == null || raw === "") return fallback;
  if (typeof raw !== "string") return raw;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
};

/**
 * Header phiếu thu theo cấu hình:
 * - department (mặc định): ORG_NAME + địa chỉ/SĐT cơ sở + tên cơ sở cuối phiếu
 * - legal_entity: tên pháp nhân + MST + địa chỉ/SĐT pháp nhân; ẩn tên cơ sở cuối
 */
export const resolveVoucherPrintHeader = (department) => {
  const mode = String(
    getSystemConfig(FEE_VOUCHER_PRINT_HEADER_MODE) ||
      FEE_VOUCHER_PRINT_HEADER_MODE_DEPARTMENT
  ).toLowerCase();
  const orgName =
    getSystemConfig("ORG_NAME") ||
    ConstantList?.ORG_NAME ||
    window?.Configs?.ORG_NAME ||
    "";
  const deptCode = department?.code;

  let legalEntity = null;
  if (
    mode === FEE_VOUCHER_PRINT_HEADER_MODE_LEGAL_ENTITY &&
    deptCode
  ) {
    const list = parseSystemConfigJson(
      getSystemConfig(FEE_VOUCHER_LEGAL_ENTITY_BY_DEPT),
      []
    );
    if (Array.isArray(list)) {
      legalEntity =
        list.find(
          (item) =>
            String(item?.departmentCode || "").trim().toLowerCase() ===
            String(deptCode).trim().toLowerCase()
        ) || null;
    }
  }

  const useLegalEntity =
    mode === FEE_VOUCHER_PRINT_HEADER_MODE_LEGAL_ENTITY && !!legalEntity;

  return {
    useLegalEntity,
    headingTitle: useLegalEntity
      ? legalEntity?.legalEntityName || ""
      : orgName,
    taxCode: useLegalEntity ? legalEntity?.taxCode || "" : "",
    // Chế độ pháp nhân vẫn hiện địa chỉ/SĐT nhưng lấy theo cấu hình pháp nhân
    showAddress: useLegalEntity
      ? !!(legalEntity?.address || legalEntity?.phone)
      : true,
    showDepartmentFooter: !useLegalEntity,
    address: useLegalEntity
      ? legalEntity?.address || ""
      : department?.address || "",
    phone: useLegalEntity
      ? legalEntity?.phone || ""
      : department?.phoneNumber || "",
    departmentName: department?.name || "",
  };
};

export const sysConfigData = localStorageService.getItem("sysConfig") || {};

export function roundUpToNearestThousand(amount) {
  if (Number(amount) <= 0 || !amount) return 0;
  if (ROUND_DOWN_HOSPITAL_FEE === ROUND_DOWN_HOSPITAL_LIST[0]?.value) {
    return Math.floor(amount / 1000) * 1000; // lam tron xuong
  } else if (ROUND_DOWN_HOSPITAL_FEE === ROUND_DOWN_HOSPITAL_LIST[2]?.value) {
    return Math.round(amount / 1000) * 1000; // lam tron gan nhta
  } else {
    return Math.ceil(amount / 1000) * 1000; // lam tron len
  }
}

/** Làm tròn tiền VND (số nguyên), xử lý sai số float (-0, 2300000.0039999997). */
export function roundVnd(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return 0;
  const rounded = Math.round(n);
  return rounded === 0 ? 0 : rounded;
}

/** Phần còn lại cho HTTT auto-fill (CK) — không âm, không -0. */
export function calcPaymentRemainder(total, paidSum) {
  return Math.max(0, roundVnd(roundVnd(total) - roundVnd(paidSum)));
}

export const getQuantityImgImageStudy = () => {
  const config = QUANTITY_IAMGE_SHOW_PRINT_FORM_IMAGE_STUDY || "[]";
  return JSON.parse(config);
};

export const getGroupServiceCampaign = () => {
  const config = GROUP_SERVICE_CAMPAIGN || "[]";
  return JSON.parse(config);
};

export const filterOptionsCustom = (options, state) => {
  let value = state || "";
  let newOptions = [];
  options.forEach((element) => {
    if (
      element.abbreviation?.toLowerCase()?.includes(value?.toLowerCase()) ||
      element.value?.toLowerCase()?.includes(value?.toLowerCase())
    )
      newOptions.push(element);
  });

  return newOptions;
};

export const renderOptionsItem = (item) => {
  return (
    <p>
      {item?.abbreviation && (
        <b>
          <i>({item?.abbreviation})</i>
        </b>
      )}{" "}
      {item?.value}
    </p>
  );
};

export const formatTestResultPrint = () => {
  const config = getSystemConfig("TEST_RESULT_PRINT") || "{}";
  const arrayFormat = JSON.parse(config);
  const obj =
    arrayFormat?.length > 0 &&
    arrayFormat?.reduce((acc, curr) => {
      acc[curr?.key] = curr?.value === "false" ? false : true;
      return acc;
    }, {});

  return obj;
};

export const getDepartmentsUser = () => {
  if (localStorageService?.getLoginUser()) {
    const { user } = localStorageService.getLoginUser();
    if (user?.personId && user?.username !== ADMIN_USERNAME) {
      if (
        user?.staff?.staffDepartments &&
        user?.staff?.staffDepartments?.length > 0
      ) {
        let formatData = user?.staff?.staffDepartments?.map(
          (el) => el?.department
        );
        // console.log("formatData", formatData);
        return formatData;
      }
    } else {
      return [];
    }
  }
  return [];
};

export const getStaffGroupsUser = () => {
  if (localStorageService?.getLoginUser()) {
    const { user } = localStorageService.getLoginUser();
    if (user?.personId && user?.username !== ADMIN_USERNAME) {
      if (user?.staff?.staffGroups && user?.staff?.staffGroups?.length > 0) {
        let formatData = user?.staff?.staffGroups?.map((el) => el?.staffGroup);
        // console.log("formatData", formatData);
        return formatData;
      }
    } else {
      return [];
    }
  }
  return [];
};

export const getDisplayAddressCRM = (patient) => {
  let address = "";
  if (patient?.addressDetail) {
    address = patient?.addressDetail;
  }
  if (patient?.communeName) {
    if (address) address += " - ";
    address += patient?.communeName;
  }
  if (patient?.districtName) {
    if (address) address += " - ";
    address += patient?.districtName;
  }
  if (patient?.provinceName) {
    if (address) address += " - ";
    address += patient?.provinceName;
  }
  return address;
};

export const convertDataLead = (lead) => {
  let age = getAgeInt(lead?.birthDate);
  let patient = {
    id: lead?.id,
    leadCode: lead?.code,
    displayName: lead?.client?.fullName || lead?.fullName,
    birthDate: lead?.client?.birthDate || lead?.birthDate,
    gender:
      LIST_GENDER_CRM?.find((el) => el?.value === lead?.gender)?.valueFormat ||
      LIST_GENDER[1]?.value,
    phoneNumber: lead?.phoneNumber,
    email: lead?.email, // email
    age: age,
    currentDetailResidence: lead?.addressDetail,
    firstPatientSource: lead?.leadSource || null,
    firstPatientSourceDetail: lead?.leadSourceDetail || null,
    currentPatientSource: lead?.leadSource || null, // giả sử như nhau
    currentPatientSourceDetail: lead?.leadSourceDetail || null,
    currentTelesale: lead?.agent
      ? {
        ...lead.agent,
        staffName: lead.agent.staffName || lead.agent.name,
      }
      : null,
    referralPartner: lead?.referralPartner,
    // marketingType: lead?.marketingType,
    // currentWard = lead?.addressDetail,
    // currentDistrict = lead?.addressDetail,
    // currentProvince =lead?.provinceName,
  };
  return patient;
};

export const dateTime = (arrDate) => {
  const rawDate = [...(arrDate || [])]; // Trích xuất mảng từ Proxy
  if (Array.isArray(rawDate) && rawDate.length === 7) {
    const [year, month, day, hour, minute, second, someThing] = rawDate;
    const modifyDate = moment([year, month - 1, day, hour, minute, second]); // Tháng - 1
    return modifyDate.isValid() ? modifyDate.format("DD/MM/YYYY h:mm A") : "";
  }
};

/**
 * Chuẩn hóa dữ liệu để gửi lên server bằng cách xóa các trường date metadata
 * mà server tự động quản lý (createDate, modifyDate, createdBy, modifiedBy)
 * Hàm này xử lý đệ quy cho nested objects và arrays
 * @param {any} data - Dữ liệu cần chuẩn hóa
 * @param {boolean} deep - Có xử lý nested objects không (mặc định: true)
 * @returns {any} - Dữ liệu đã được chuẩn hóa
 */
export const normalizeDataForServer = (data, deep = true) => {
  if (data === null || data === undefined) {
    return data;
  }

  // Nếu là array, xử lý từng phần tử
  if (Array.isArray(data)) {
    return data.map((item) => normalizeDataForServer(item, deep));
  }

  // Nếu không phải object, trả về nguyên bản
  if (typeof data !== "object" || data instanceof Date) {
    return data;
  }

  // Tạo object mới để không mutate object gốc
  const normalized = {};

  // Danh sách các trường cần xóa (metadata fields)
  const fieldsToRemove = [
    "createDate",
    "modifyDate"
  ];

  for (const key in data) {
    // Bỏ qua các trường metadata
    if (fieldsToRemove.includes(key)) {
      continue;
    }

    const value = data[key];

    // Nếu deep = true và value là object/array, xử lý đệ quy
    if (deep) {
      if (Array.isArray(value)) {
        normalized[key] = value.map((item) =>
          normalizeDataForServer(item, deep)
        );
      } else if (value !== null && typeof value === "object" && !(value instanceof Date)) {
        normalized[key] = normalizeDataForServer(value, deep);
      } else {
        normalized[key] = value;
      }
    } else {
      normalized[key] = value;
    }
  }

  return normalized;
};

export const getLastName = (name) => {
  if (name) {
    return name?.trim()?.split(" ").pop().charAt(0);
  }
  return "";
};

export const calcLeftOffset = (columns, columnIndex) => {
  let left = 0;
  for (let i = 0; i < columnIndex; i++) {
    const col = columns[i];
    if (!col.isHide && col.fixed === "left") {
      left += parseInt(col.width || 0, 10);
    }
  }
  return left;
};

export const getPositionCodes = () => {
  const config = getSystemConfig("POSITION_CODES") || "[]";
  const arrayFormat = JSON.parse(config);

  return arrayFormat;
};

export const getPositionKTV = () => {
  const config = getSystemConfig("POSITION_KTVS") || "[]";
  const arrayFormat = JSON.parse(config);

  return arrayFormat;
};

export const getPromotionCodes = () => {
  const config = getSystemConfig("PROMOTION_CODES") || "[]";
  const arrayFormat = JSON.parse(config);

  return arrayFormat;
};

export const getPositionCodesTreatment = () => {
  const config = getSystemConfig("POSITION_CODES_TREATMENT") || "[]";
  const arrayFormat = JSON.parse(config);

  return arrayFormat;
};

export const getDefaultRoom = (department, service) => {
  const rooms = service?.serviceRooms?.filter(
    (el) => el?.room?.department?.id === department?.id
  );
  return rooms?.find((el) => el?.isDefault) || rooms?.[0] || null;
};

export const getDoctorPositionCodes = () => {
  const config =
    getSystemConfig("DOCTOR_POSITION_CODES") ||
    window.Configs.DOCTOR_POSITION_CODES ||
    "[]";
  const arrayFormat = JSON.parse(config);

  return arrayFormat;
};

export const getTechnicianPositionCodes = () => {
  const config =
    getSystemConfig("TECHNICIAN_POSITION_CODES") ||
    window.Configs.TECHNICIAN_POSITION_CODES ||
    "[]";
  const arrayFormat = JSON.parse(config);

  return arrayFormat;
};

export const getNursePositionCodes = () => {
  const config =
    getSystemConfig("NURSE_POSITION_CODES") ||
    window.Configs.NURSE_POSITION_CODES ||
    "[]";
  const arrayFormat = JSON.parse(config);

  return arrayFormat;
};

export const getTelesalePositionCodes = () => {
  const config =
    getSystemConfig("TELESALE_POSITION_CODES") ||
    window.Configs.TELESALE_POSITION_CODES ||
    "[]";
  const arrayFormat = JSON.parse(config);

  return arrayFormat;
};

export const config_resizeImg = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
  initialQuality: 0.6,
};

export function validateMaxTotalAmountConsultant(staffRevenues) {
  if (!Array.isArray(staffRevenues)) return false;
  //lấy ra tvv và ktv
  const POSITION_KTVS_CONSULTANT = [...getPositionKTV(), POSITION_CONSULTANT];

  const staffsKtv_Consultant = staffRevenues?.filter((staff) =>
    POSITION_KTVS_CONSULTANT?.some(
      (el) =>
        el === staff?.position?.code || el === staff?.staff?.position?.code
    )
  );

  const totalRevenue = staffsKtv_Consultant?.reduce((acc, curr) => {
    const percentage = parseFloat(curr?.percentRevenue) || 0;

    return +acc + percentage;
  }, 0);

  if (Math.abs(totalRevenue - 100) > 0.01) {
    return false;
  }
  return true;
}

export function validateMaxTotalAmountTelesale(staffRevenues) {
  if (!Array.isArray(staffRevenues)) return false;
  const staffsTelesale = staffRevenues?.filter(
    (staff) =>
      staff?.position?.code === POSITION_TELESALE ||
      staff?.staff?.position?.code === POSITION_TELESALE
  );
  if (staffsTelesale?.length === 0) return true;

  const totalRevenue = staffsTelesale?.reduce((acc, curr) => {
    const percentage = parseFloat(curr?.percentRevenue) || 0;
    return +acc + percentage;
  }, 0);

  if (Math.abs(totalRevenue - 100) > 0.01) {
    return false;
  }
  return true;
}

export function validateMaxTotalDiffTelesale(staffRevenues) {
  if (!Array.isArray(staffRevenues)) return false;

  // Filter out telesale positions
  const staffsDiffTelesale = staffRevenues?.filter(
    (staff) =>
      staff?.position?.code !== POSITION_TELESALE &&
      staff?.staff?.position?.code !== POSITION_TELESALE
  );

  // If no non-telesale staff, validation passes
  if (staffsDiffTelesale?.length === 0) return true;

  // Calculate total percentage
  const totalRevenue = staffsDiffTelesale?.reduce((acc, curr) => {
    const percentage = parseFloat(curr?.percentRevenue) || 0;
    return acc + percentage;
  }, 0);

  // Allow small floating point differences (within 0.01)
  // This handles cases like 83.33 + 4.17 + 12.5 = 100.00
  if (Math.abs(totalRevenue - 100) < 0.01) {
    return true;
  }

  return false;
}

export function validateEqualsSourceDiffirentTelesale(staffRevenues) {
  if (!Array.isArray(staffRevenues)) return false;
  //1 mảng => reduce =>

  const formatStaffReducer = staffRevenues.reduce((acc, curr) => {
    const key = curr?.source?.id ?? "unknown";
    let telesale;
    let diffirentTelesale;
    if (
      curr?.position?.code === POSITION_TELESALE ||
      curr?.staff?.position?.code === POSITION_TELESALE
    ) {
      telesale = curr;
    }

    if (
      curr?.position?.code !== POSITION_TELESALE &&
      curr?.staff?.position?.code !== POSITION_TELESALE
    ) {
      diffirentTelesale = curr;
    }

    if (!acc[key]) {
      acc[key] = {
        items: [curr],
        source: curr?.source ?? null,
        totalTelesalePercent: +telesale?.percentRevenue || 0,
        totalDiffirentTelesale: +diffirentTelesale?.percentRevenue || 0,
      };
    } else {
      acc[key] = {
        ...acc[key],
        items: [...acc[key].items, curr],
        totalTelesalePercent:
          +acc[key].totalTelesalePercent + (+telesale?.percentRevenue || 0),
        totalDiffirentTelesale:
          +acc[key].totalDiffirentTelesale +
          (+diffirentTelesale?.percentRevenue || 0),
      };
    }

    return acc;
  }, {});
  const groupedObject = Object.values(formatStaffReducer);

  const sourceInvalid = groupedObject?.find((el) => {
    if (
      el?.totalTelesalePercent > 0 &&
      Math.abs(el?.totalDiffirentTelesale - el?.totalTelesalePercent) > 0.01
    ) {
      return el;
    }
    return null;
  });

  if (sourceInvalid) return false;
  return true;
}

export function validateSelectDiffirentTelesale(staffRevenues) {
  if (!Array.isArray(staffRevenues)) return false;
  let isUniqueSale = true;
  if (staffRevenues?.length === 1) {
    if (staffRevenues?.[0]?.position) {
      isUniqueSale = staffRevenues?.[0]?.position?.code !== POSITION_TELESALE;
    }
    if (staffRevenues?.[0]?.staff) {
      isUniqueSale =
        staffRevenues?.[0]?.staff?.position?.code !== POSITION_TELESALE;
    }
  }

  return isUniqueSale;
}

export function validateSelectTelesale(staffRevenues) {
  if (!Array.isArray(staffRevenues)) return false;
  const isLeast = staffRevenues?.some(
    (el) =>
      el?.position?.code === POSITION_TELESALE ||
      el?.staff?.position?.code === POSITION_TELESALE
  );

  return isLeast;
}

export function validateVoucherPaymentMethods(value) {
  const {
    totalOfMethod,
    paymentMethodValue,
    paymentBank,
    bankName,
    bankAccountNumber,
  } = value;

  if (roundVnd(totalOfMethod) < 0) {
    return this.createError({
      path: `${this.path}.totalOfMethod`,
      message: "Số tiền không được âm",
    });
  }

  if (
    paymentMethodValue?.characteristic ===
    PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT &&
    totalOfMethod > 0
  ) {
    if (!paymentBank || !bankName || !bankAccountNumber) {
      return this.createError({
        path: `${this.path}.paymentBank`,
        message: "Bắt buộc chọn STK ngân hàng",
      });
    }
  }
  if (
    paymentMethodValue?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_POS &&
    totalOfMethod > 0
  ) {
    if (!paymentBank || !bankName || !bankAccountNumber) {
      return this.createError({
        path: `${this.path}.paymentBank`,
        message: "Bắt buộc chọn máy pos",
      });
    }
  }

  if (
    PAYMENT_METHOD_CODES_REQUIRED_INTEREST_RATE?.includes(
      paymentMethodValue?.code
    ) &&
    totalOfMethod > 0
  ) {
    if (
      value?.interestRateType == null ||
      value?.periodMonths == null ||
      value?.interestRate == null
    ) {
      return this.createError({
        path: `${this.path}.interestRatePeriodId`,
        message: "Bắt buộc chọn kì hạn lãi suất",
      });
    }
  }

  return true;
}

export const isPhoneNumber = (text) => {
  return /^[0-9]+$/.test(text);
};

/**
 * Lấy staffName từ danh sách participants theo mã chức danh,
 * ưu tiên participant có isMain = true, sau đó theo thứ tự tạo sớm nhất (createdDate)
 *
 * @param {Object[]} dataParticipants - Danh sách participants
 * @param {String[]} codes - Danh sách mã chức danh (ví dụ: ["DOCTOR", "CD_0076"])
 * @param {Number} index - Vị trí lấy sau khi đã sắp xếp (0 = ưu tiên nhất)
 * @returns {String} staffName
 */
export const getStaffByCodesFromParticipants = (
  dataParticipants,
  codes = [],
  index = 0
) => {
  const participants =
    dataParticipants?.filter(
      (ep) => codes.includes(ep?.position?.code)
    ) || [];

  participants.sort((a, b) => {
    // isMain: true trước, null/undefined coi như false
    const m1 = a?.isMain === true ? 1 : 0;
    const m2 = b?.isMain === true ? 1 : 0;

    if (m1 !== m2) {
      return m2 - m1;
    }

    // so sánh cả ngày + giờ (timestamp)
    return (
      new Date(a.createDate).getTime() -
      new Date(b.createDate).getTime()
    );
  });

  return participants[index]?.staff?.staffName ?? "";
};

/**
 * Lấy staffName theo danh sách code chức danh từ staffRevenues
 * @param {object[]} dataStaffRevenues - danh sách staffRevenues
 * @param {string[]} codes - danh sách mã chức danh (ví dụ: ["TELESALE", "SALE"])
 * @param {number} index - thứ tự (0 = người đầu tiên, 1 = người thứ 2, …)
 * @returns {string} staffName
 */
export const getStaffByCodesFromStaffRevenues = (
  dataStaffRevenues,
  codes = [],
  index = 0
) => {
  let staffRevenues =
    dataStaffRevenues?.filter((ep) => codes.includes(ep?.position?.code)) || [];

  // Lấy theo thứ tự tạo sớm nhất
  staffRevenues = staffRevenues.sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  );

  return staffRevenues[index] ? staffRevenues[index].staff?.staffName : "";
};

//  Lấy danh sách giới hạn phương thức thanh toán (đảm bảo luôn trả về mảng)
export const getPaymentMethodLimits = () => {
  let config =
    // getSystemConfig("PAYMENT_METHOD_LIMITS") ||
    window.Configs?.PAYMENT_METHOD_LIMITS || "[]";

  // Nếu config là mảng thật thì trả về luôn
  if (Array.isArray(config)) return config;
  // Nếu là chuỗi JSON thì parse, nếu lỗi thì trả mảng rỗng
  try {
    const parsed = JSON.parse(config);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.warn("⚠️ Lỗi parse PAYMENT_METHOD_LIMITS:", error, config);
    return [];
  }
};

// ✅ Kiểm tra xem có giới hạn phương thức thanh toán không
export const checkPaymentMethodLimits = () => {
  const pmLimits = getPaymentMethodLimits();
  return Array.isArray(pmLimits) && pmLimits.length > 0;
};

export function parseVoucherDate(arr) {
  if (!arr) return null;
  const [y, m, d, h = 0, min = 0] = arr;
  return moment.utc(Date.UTC(y, m - 1, d, h, min)).format("YYYY-MM-DD");
}

export const getSourceCustomerCompanionCode = () => {
  const config = getSystemConfig("LIST_DEFAULT_SOURCE_FOR_COMPANION") || "[]";
  const arrayFormat = JSON.parse(config);

  return arrayFormat;
};

export const getSourceDepentPlatform = () => {
  const config = getSystemConfig("SOURCE_DEPENDENT_PLATFORM") || "[]";
  const arrayFormat = JSON.parse(config);

  const optionsFormat = arrayFormat?.map((el) => ({ value: el, name: el }));

  return optionsFormat;
};

export const getFreePromotionByConfig = (data) => {
  let item = data?.find((el) => el?.code === PROMOTION_DEFAULT_CODE);
  if (item) return item;
  return null;
};

export const getWarrantyPeriods = (amount, warrantyPeriods) => {
  const warrantyPeriod = warrantyPeriods?.find((el) => {
    if (amount >= el?.orderPriceFrom && amount <= el?.orderPriceTo) return el;
  });
  return warrantyPeriod;
};
export const handleDefaultServiceWarranty = (service, feeItemSerive) => {
  const warrantyPeriods = service?.warrantyPeriods;
  let amountItemWarranty = feeItemSerive?.price ? +feeItemSerive?.price : 0;
  const warrantyPeriod = getWarrantyPeriods(
    amountItemWarranty,
    warrantyPeriods
  );
  return {
    warrantyUnit: warrantyPeriod?.warrantyUnit,
    warrantyDuration: warrantyPeriod?.warrantyQuantity,
    warrantyTotalTimes: warrantyPeriod?.warrantyTimes,
    hasWarranty: warrantyPeriod ? true : false,
  };
};

export const renderOptionsStaff = (option) => {
  const staffName = option?.staffName || "Không có tên";
  const staffCode = option?.code;

  const shortNames = option?.staffDepartments
    ?.map((sd) => sd?.department?.shortName)
    .filter(Boolean);

  const shortNameDisplay = shortNames?.length
    ? `(${shortNames.join(", ")})`
    : "";

  const parts = [staffName];
  if (staffCode) parts.push(staffCode);
  if (shortNameDisplay) parts.push(shortNameDisplay);

  return (
    <div style={{ fontSize: "14px", color: "#000", padding: "4px 0" }}>
      {parts.join(" - ")}
    </div>
  );
};

/** Mã KH/BN cho form in — gom các field thường gặp trên DTO patient/voucher. */
export const getPrintPatientCode = (...sources) => {
  for (const source of sources) {
    if (!source) continue;
    const code =
      source?.code ||
      source?.customerCode ||
      source?.patientCode ||
      source?.patientInfo?.code ||
      source?.patientInfo?.customerCode ||
      source?.patientInfo?.patientCode ||
      source?.patient?.code ||
      source?.patient?.customerCode ||
      source?.patient?.patientCode ||
      "";
    if (code) return code;
  }
  return "";
};

/** Hậu tố `- <mã>` khi in cạnh tên KH/BN (chỉ khi form không có dòng Mã KH riêng). */
export const formatPrintPatientCodeSuffix = (...sources) => {
  let besideName = true;
  if (typeof sources[sources.length - 1] === "boolean") {
    besideName = sources.pop();
  }
  if (!besideName) return "";
  const code = getPrintPatientCode(...sources);
  return code ? `- ${code}` : "";
};

/** Hậu tố ` - <mã>` khi in cạnh tên KH/BN (chỉ khi form không có dòng Mã KH riêng). */
export const formatPrintPatientCodeAfterName = (...sources) => {
  let besideName = true;
  if (typeof sources[sources.length - 1] === "boolean") {
    besideName = sources.pop();
  }
  if (!besideName) return "";
  const code = getPrintPatientCode(...sources);
  return code ? ` - ${code}` : "";
};

export const hideMiddleDigits = (phoneNumber) => {
  if (!phoneNumber) {
    return "";
  }
  const isShowPhoneByRole = isRoleHisShowFullPhone();
  if (isShowPhoneByRole) {
    return phoneNumber;
  }
  const hidePhoneConfig = HIDE_PHONE_NUMBER; // true / false
  // Tắt ẩn hoặc không phải chuỗi → trả nguyên bản
  if (!hidePhoneConfig) {
    return phoneNumber ?? "";
  }
  const cleaned = (phoneNumber ?? "").replace(/\D/g, ""); // Chỉ giữ số
  if (cleaned.length < 8) return phoneNumber; // Quá ngắn → không ẩn

  // Luôn hiển thị: 3 số đầu + ***** + 3 số cuối (đẹp nhất cho VN)
  const prefix = cleaned.slice(0, 3);
  const suffix = cleaned.slice(-3);

  return `${prefix}*****${suffix}`;
};

/** Hiển thị một hoặc nhiều SĐT (ẩn theo quyền HIS_SHOW_FULL_PHONE_NUMBER + HIDE_PHONE_NUMBER). */
export const formatDisplayPhoneNumbers = (phones) => {
  const list = (Array.isArray(phones) ? phones : [phones]).filter(Boolean);
  if (!list.length) return "";
  return list.map((phone) => hideMiddleDigits(phone)).join(" | ");
};

const PATIENT_PHONE_FIELDS = new Set([
  "phoneNumber",
  "phone_number",
  "patientPhoneNumber",
  "clientPhoneNumber",
  "subPhoneNumber",
  "phoneNumber2",
  "phoneNumber3",
  "phoneNumber4",
]);

export const isPatientPhoneField = (fieldName) => {
  if (!fieldName || typeof fieldName !== "string") return false;
  const leafField = fieldName.split(".").pop();
  return PATIENT_PHONE_FIELDS.has(leafField);
};

export const isPhoneDisplayLabel = (label) => {
  if (!label) return false;
  const text = String(label).toLowerCase();
  return (
    text.includes("sđt") ||
    text.includes("sdt") ||
    text.includes("điện thoại") ||
    text.includes("phone")
  );
};

const COPYABLE_CODE_FIELD_SUFFIX = /Code$/;
const COPYABLE_CODE_FIELD_NAMES = new Set([
  "code",
  "customerCode",
  "patientCode",
  "lookUpCode",
  "referralPartnerCode",
  "storeCode",
]);

export const isCopyableCodeField = (fieldName) => {
  if (!fieldName || typeof fieldName !== "string") return false;
  const leafField = fieldName.split(".").pop();
  return (
    COPYABLE_CODE_FIELD_NAMES.has(leafField) ||
    COPYABLE_CODE_FIELD_SUFFIX.test(leafField)
  );
};

export const isCopyableCodeLabel = (label) => {
  if (!label) return false;
  const text = String(label).toLowerCase();
  return text.includes("mã") || text.includes("ma kh") || text.includes("ma bn");
};

export const isCopyableCodeTitle = (title) => {
  if (!title || typeof title === "function") return false;
  return isCopyableCodeLabel(title);
};

export const formatPhoneDisplayValue = (value) => {
  if (value == null || value === "") return value;
  const str = String(value);
  if (str.includes("|")) {
    return str
      .split("|")
      .map((part) => hideMiddleDigits(part.trim()))
      .filter(Boolean)
      .join(" | ");
  }
  return hideMiddleDigits(str);
};

export const DisplayPhone = ({ value, phones }) => {
  if (phones?.length) {
    return formatDisplayPhoneNumbers(phones);
  }
  if (!value) return null;
  return hideMiddleDigits(value);
};

export function removeLeadingSlash(url) {
  if (!url) return url;
  // Nếu url bắt đầu bằng '/', loại bỏ
  if (url.startsWith("/")) {
    return url.substring(1);
  }
  return url;
}

export const getListCodeSourceCTV = () => {
  const config = getSystemConfig("LIST_CODE_SOURCE_CTV") || "[]";
  const arrayFormat = JSON.parse(config);

  return arrayFormat;
};

export const getListCodeSourceDiChung = () => {
  const config = getSystemConfig("LIST_CODE_SOURCE_DI_CHUNG") || "[]";
  const arrayFormat = JSON.parse(config);

  return arrayFormat;
};

export const handleCopyText = (text, successMessage = "Đã copy") => {
  if (text == null || text === "") return;
  const value = String(text);
  const onSuccess = () => toast.success(successMessage);
  const onError = () => toast.error("Copy thất bại");

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(value)
      .then(onSuccess)
      .catch(onError);
  } else {
    const textArea = document.createElement("textarea");
    textArea.value = value;
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand("copy");
      if (successful) onSuccess();
      else onError();
    } catch (err) {
      onError();
    }
    document.body.removeChild(textArea);
  }
};

export const handleCopyCode = (code) => {
  handleCopyText(code, "Đã copy mã");
};

export const handleCopyPhone = (phoneNumber) => {
  if (!isRoleHisCopyPhone()) {
    toast.error("Bạn không có quyền copy số điện thoại");
    return;
  }
  handleCopyText(phoneNumber, "Đã copy số điện thoại");
};